import { FC, useContext } from 'react';
import { MapContainer, Marker as MarkerOSM, TileLayer } from 'react-leaflet';
import Leaflet from 'leaflet';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { MainContext } from 'contexts/MainContext';
import { mapSupplier, imgCenterPoint } from 'constants/generic';

interface DetailsMapProps {
  lat: number;
  lng: number;
  zoom?: number;
}
const DetailsMap: FC<DetailsMapProps> = ({ lat = 0, lng = 0, zoom = 14 }) => {
  const {
    initSiteData
  } = useContext(MainContext);

  const iconCenter = new Leaflet.Icon({
    iconUrl: imgCenterPoint,
    iconSize: [16, 28],
  });

  const generateMapUrl = (marker: { lat: number; lng: number; label: string }) => {
    const detailsSize = document
      .querySelector('.details-block .title-underline')
      ?.getBoundingClientRect();
    const size = { x: detailsSize?.width || 1000, y: 300 };

    const baseUrl = 'https://maps.googleapis.com/maps/api/staticmap';
    const genericUrl = `?key=${initSiteData?.apiKey || ''}&size=${size.x}x${size.y}&`;
    const newMarkerUrl = `markers=color:${'red'}%7Clabel:${marker.label}%7C${marker.lat},${
      marker.lng
    }&`;

    return baseUrl.concat(genericUrl, newMarkerUrl);
  };

  return (
    <div style={{ overflow: 'hidden', height: 300 }}>
      {mapSupplier === 'google' && (
        <img
          style={{ width: '100%' }}
          src={generateMapUrl({ lat: lat, lng, label: '' })}
          alt="map"
        />
      )}

      {mapSupplier === 'osm' && (
        <div className="map-wr">
          <MapContainer center={{ lat, lng }} zoom={zoom}>
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <MarkerOSM zIndexOffset={10} position={{ lat, lng }} icon={iconCenter} />
          </MapContainer>
        </div>
      )}
    </div>
  );
};

export default withErrorBoundary(DetailsMap, 'DetailsMap');
